/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { DatePicker as SDatePicker } from 'sarsaparilla';

function DatePicker({ minValue, maxValue, onVisibleRangeChange, ...rest }) {
    const datePickerRef = useRef();
    const calendarRef = useRef({ visibleRangeStartRef: null });

    /**
     * Adding this useEffect to listen maxValue or minValue changes
     */
    useEffect(() => {
        if (maxValue || minValue) {
            datePickerRef?.current?.validate();
        }
    }, [maxValue, minValue]);

    const handleOnVisibleRangeChange = (range) => {
        const { start } = range;
        const visibleRangeStart = start?.toString();
        if (visibleRangeStart !== calendarRef?.current?.visibleRangeStartRef) {
            onVisibleRangeChange(range);
            calendarRef.current.visibleRangeStartRef = visibleRangeStart;
        }
    };

    return (
        <SDatePicker
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            ref={datePickerRef}
            minValue={minValue}
            maxValue={maxValue}
            onVisibleRangeChange={handleOnVisibleRangeChange}
        />
    );
}

DatePicker.propTypes = {
    minValue: PropTypes.object,
    maxValue: PropTypes.object,
    onVisibleRangeChange: PropTypes.func,
};

DatePicker.defaultProps = {
    onVisibleRangeChange: () => {},
};

export default DatePicker;
